import { render, staticRenderFns } from "./TableTabs.vue?vue&type=template&id=a00f783e"
import script from "./TableTabs.vue?vue&type=script&lang=js"
export * from "./TableTabs.vue?vue&type=script&lang=js"
import style0 from "./TableTabs.vue?vue&type=style&index=0&id=a00f783e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports